import { render, staticRenderFns } from "./BookingMessageTemplates.vue?vue&type=template&id=37fb2527&scoped=true"
import script from "./BookingMessageTemplates.vue?vue&type=script&lang=js"
export * from "./BookingMessageTemplates.vue?vue&type=script&lang=js"
import style0 from "./BookingMessageTemplates.vue?vue&type=style&index=0&id=37fb2527&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37fb2527",
  null
  
)

export default component.exports